import installInfoKacheln from './config';

export default installInfoKacheln;
